import type { SceneObject } from "../../SceneHost";
import { svgGroupTransform } from "../../transform/rotate";

const SVG_NS = "http://www.w3.org/2000/svg";

/**
 * Картинка — РОДНАЯ svg-картинка, без вёрстки внутри SVG.
 *
 * Раньше она была `<img>` внутри foreignObject. На iOS такая вставка рисуется
 * поверх всего SVG независимо от порядка слоёв: штрих, проведённый поверх
 * картинки, уходил под неё, и стрелки «на передний план» не помогали — они
 * меняют порядок, а WebKit его для вёрстки внутри SVG не соблюдает.
 *
 * Картинке вёрстка не нужна вовсе: `<image>` умеет и размер, и растяжение,
 * и поворот. Заодно пропала причина, по которой её вообще заносили в слой
 * HTML-объектов, — своего окна ей больше не требуется.
 */

export function syncImageObjectOnGroup(
  g: SVGGElement,
  obj: SceneObject,
  assetContentUrl: (assetId: string) => string
): boolean {
  if (!obj.assetId) return false;
  const w = typeof obj.w === "number" ? obj.w : 200;
  const h = typeof obj.h === "number" ? obj.h : 150;
  g.setAttribute("transform", svgGroupTransform(obj));

  // Белая подложка: у картинок с прозрачностью иначе просвечивает доска,
  // а раньше её давал фон обёртки.
  let bg = g.querySelector("rect.wb-scene-image__bg") as SVGRectElement | null;
  if (!bg) {
    bg = document.createElementNS(SVG_NS, "rect");
    bg.setAttribute("class", "wb-scene-image__bg");
    bg.setAttribute("fill", "#ffffff");
    g.appendChild(bg);
  }
  bg.setAttribute("x", "0");
  bg.setAttribute("y", "0");
  bg.setAttribute("width", String(w));
  bg.setAttribute("height", String(h));

  let img = g.querySelector("image") as SVGImageElement | null;
  if (!img) {
    img = document.createElementNS(SVG_NS, "image");
    // Растягиваем по рамке, как было у object-fit: fill.
    img.setAttribute("preserveAspectRatio", "none");
    g.appendChild(img);
  }
  img.setAttribute("x", "0");
  img.setAttribute("y", "0");
  img.setAttribute("width", String(w));
  img.setAttribute("height", String(h));

  const nextSrc = assetContentUrl(String(obj.assetId));
  if (img.getAttribute("href") !== nextSrc) {
    img.setAttribute("href", nextSrc);
  }
  return true;
}

export function renderImageObject(
  obj: SceneObject,
  assetContentUrl: (assetId: string) => string
): SVGGElement | null {
  if (!obj.assetId) return null;
  const g = document.createElementNS(SVG_NS, "g");
  g.setAttribute("class", "wb-scene-obj wb-scene-obj--image");
  g.setAttribute("data-object-id", obj.id);
  syncImageObjectOnGroup(g, obj, assetContentUrl);
  return g;
}
